import { useEffect, useId, useRef, type ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  danger?: boolean;
  confirmDisabled?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  danger,
  confirmDisabled,
  busy,
  onConfirm,
  onCancel,
}: Props) {
  const titleId = useId();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const el = ref.current;
    if (el && !el.contains(document.activeElement)) el.focus();
    return () => previous?.focus?.();
  }, []);

  return (
    <div className="overlay" onMouseDown={(e) => e.target === e.currentTarget && onCancel()}>
      <div
        ref={ref}
        className="dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        onKeyDown={(e) => {
          if (e.key === 'Escape') onCancel();
        }}
      >
        <h2 id={titleId}>{title}</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (!confirmDisabled && !busy) onConfirm();
          }}
        >
          <div className="dialog-body">{children}</div>
          <div className="dialog-actions">
            <button type="button" className="btn" onClick={onCancel}>
              Annuler
            </button>
            <button
              type="submit"
              className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`}
              disabled={confirmDisabled || busy}
            >
              {busy ? 'Veuillez patienter…' : confirmLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
